import { CONTACT_REQUEST_MESSAGES, ContactRequestMessages } from "./contact-request-messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";

export type ContactPhoneSectionMessages = ContactRequestMessages &
  ActionButtonMessages & {
    phoneNumberSection: string;

    //YUP ERRORS
    errorRequiredDdiMobile: string;
    errorRequiredDddMobile: string;
    errorRequiredMobilePhone: string;
    errorRequiredDdiPhone1: string;
    errorRequiredDddPhone1: string;
    errorRequiredPhone1: string;
    errorInvalidPhone: string;

    //DDI OPTIONS
    ddiBrazilOption: string;
    noDDI: string;

    //FORM LABELS
    mobileSubTitle: string;
    phone1SubTitle: string;
    phone2SubTitle: string;
    phone1Label: string;
    phone2Label: string;
    ddiMobileLabel: string;
    dddMobileLabel: string;
    mobilePhoneLabel: string;
    ddiPhone1Label: string;
    dddPhone1Label: string;
    ddiPhone2Label: string;
    dddPhone2Label: string;
  };

export const CONTACT_PHONE_MESSAGES: ContactPhoneSectionMessages = {
  phoneNumberSection: "Telefones",

  //YUP ERRORS
  errorRequiredDdiMobile: "Digite um DDI para celular!",
  errorRequiredDddMobile: "Digite um DDD para celular!",
  errorRequiredMobilePhone: "Digite um número de celular!",
  errorRequiredDdiPhone1: "Digite um DDI para o telefone 1!",
  errorRequiredDddPhone1: "Digite um DDD para o telefone 1!",
  errorRequiredPhone1: "Digite um número de telefone!",
  errorInvalidPhone: "Digite um telefone válido",

  //DDI OPTIONS
  ddiBrazilOption: "Brasil",
  noDDI: "Nenhum",

  //FORM LABELS
  mobileSubTitle: "Celular",
  phone1SubTitle: "Telefone",
  phone2SubTitle: "Telefone 2",
  phone1Label: "Telefone",
  phone2Label: "Telefone 2",
  ddiMobileLabel: "País",
  dddMobileLabel: "DDD",
  mobilePhoneLabel: "Celular",
  ddiPhone1Label: "País",
  dddPhone1Label: "DDD",
  ddiPhone2Label: "País",
  dddPhone2Label: "DDD",

  ...CONTACT_REQUEST_MESSAGES,

  //ACTION BUTTONS
  ...ACTION_BUTTON_MESSAGES,
};
